module.exports = __webpack_public_path__ + "img/yegr.c8dab4cb.png";